<template>
  <ion-page>
    <ion-content :fullscreen="true">
      <div class="row">
        <HeaderComp currentPage="about"></HeaderComp>

        <VisionContent class="text-black" />

        <FooterComp></FooterComp>
      </div>
    </ion-content>
  </ion-page>
</template>
<script>
import HeaderComp from '@/components/layouts/HeaderComp'
import FooterComp from '@/components/layouts/FooterComp'
import VisionContent from '@/views/content/VisionContent'
import { IonContent, IonPage } from '@ionic/vue';
export default {
  components: { VisionContent, FooterComp, HeaderComp, IonContent, IonPage },

  data() {
    return {}
  },
}
</script>
